import type {DirectoryItem, FileTreePagePayload} from '@github-ui/code-view-types'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

type TreeNavigationResponse = {
  payload: FileTreePagePayload
}

type TreeDataRouterResponse = {
  payload: {
    codeViewTreeRoute: FileTreePagePayload
  }
}

export type NormalizedTreePayload = {
  tree: {
    items: DirectoryItem[]
    totalCount: number
  }
}

export async function fetchTree(contentUrl: string) {
  const response = await verifiedFetchJSON(`${contentUrl}?noancestors=1`)

  if (!response.ok) {
    throw new Error(`Failed to fetch tree data: ${response.status} ${response.statusText}`)
  }

  const data: TreeNavigationResponse | TreeDataRouterResponse = await response.json()

  let normalizedPayload: NormalizedTreePayload

  if ('codeViewTreeRoute' in data.payload) {
    // Tree Data Router response
    normalizedPayload = {
      tree: {
        items: data.payload.codeViewTreeRoute.tree.items,
        totalCount: data.payload.codeViewTreeRoute.tree.totalCount,
      },
    }
  } else {
    // Tree Navigation response
    normalizedPayload = {
      tree: {
        items: data.payload.tree.items,
        totalCount: data.payload.tree.totalCount,
      },
    }
  }

  return normalizedPayload
}
